import { Permissao } from "../api/dto/permissao";
import { CriptografiaUtil } from "./criptografia-util";

export class AuthUtil {

    public static PERMISSOES_KEY = 'permissoes'

    public static verificarPermissao(nome: string): boolean {
        let permissoes = this.getPermissoes();
        let existe: boolean = false;
        for (const permissao of permissoes) {
            if (nome === permissao) {
                existe = true;
            }
        }
        return existe;
    }

    public static getPermissoes(): String[] {
        const permissoesCripted = window.sessionStorage.getItem(this.PERMISSOES_KEY);
        if (permissoesCripted) {
            const permissoesDecripted = CriptografiaUtil.decrypt(permissoesCripted);
            if (permissoesDecripted) {
                return JSON.parse(permissoesDecripted);
            }
        }
        return [];
    }

}